export default {
  h1_services: "Дәрігерлерге арналған жасанды интеллект қызметтері",
  Services: "Қызметтер",
  eduServices: "Курстар",
  AIServices: "Қызметтер",
  mg: "Маммография",
  dx: "Кеуде рентгенографиясы және флюорография",
  "Go to service": "Қызметке өту",
  "Service banner text":
    "Сіздің мекемеңізге жасанды интеллект енгізудің әсерін есептеңіз",
  Calc: "Есептеу",
  "Services title": "Қызметтер тізімі | " + process.env.VUE_APP_INSTALL_NAME,
  "No description service": "Сипаттама берілмеген",
  "Services cannot loading": "Қызмет уақытша қолжетімсіз. Кейінірек көріңіз",
  "Cash calc title": "Жинақ есебі | " + process.env.VUE_APP_INSTALL_NAME,
  "Cash calc": "Жинақ есебі",
  "Cash calc desc": "Сіз ЖИ арқылы қанша ресурсты үнемдей аласыз",
  "Cash calc desc about":
    "Мекемеңіз туралы деректерді енгізіңіз. Калькулятордан шыққаннан кейін деректер өшіріледі.",
  "Average cash": "Рентгенолог дәрігердің орташа айлық жалақысы",
  "Study calc count": "Мекемеңіздегі айлық зерттеулер саны",
  mmg: "Маммография",
  ddx: "Кеуде рентгенографиясы",
  ct: "Кеуде КТ",
  "Start calc": "Есептеу",
  economy: "Жинақ",
  rub: " теңге",
  "calc time": " сағ",
  "Calc summary": "Жылына барлығы",
  "Without AI": "Жасанды интеллектсіз",
  "With AI": "Жасанды интеллектпен",
  "Count calc short": "Саны ",
  "Calc in Year": " жылына",
  "Calc item 1": "Бір зерттеудің сипаттамасы, мин",
  "Calc item 2": "Бір зерттеудің сипаттамасының бағасы, теңге",
  "Calc item 3": "Сипаттамаға кететін шығын",
  "Calc item 4": "Сипаттамаға кететін уақыт, сағ",
  mmg__count: "ММГ",
  ddx__count: "РГ/ФЛГ",
  ct__count: "КТ",
  "Calc info": "Есептеу әдістемесі",
};
